import React from "react";
import { Link as GatsbyLink } from "gatsby";

// S3/CloudFront 301s every page URL without a trailing slash to the slashed
// one, and the sitemap and canonical URLs use the slashed form. Normalise
// internal links here so a CMS field like `/cloud-adoption` doesn't cost a
// redirect (and doesn't leave the real URL with no internal links).
//
// Leaves alone: external URLs, anchors (#x), and paths whose last segment
// looks like a file (/img/x.png, /files/y.pdf).
export const withTrailingSlash = (to) => {
  if (typeof to !== "string" || !to.startsWith("/") || to.startsWith("//")) {
    return to;
  }
  const match = to.match(/^([^?#]*)(.*)$/);
  const path = match[1];
  const rest = match[2];
  const lastSegment = path.split("/").pop();
  if (path.endsWith("/") || lastSegment.includes(".")) return to;
  return `${path}/${rest}`;
};

export const Link = ({ to, ...props }) => (
  <GatsbyLink to={withTrailingSlash(to)} {...props} />
);

export default Link;
